export default () => {
  $('[data-toggle="tooltip"]').each((_, el) => {
    const $el = $(el);
    if ($el.data('bs.tooltip')) {
      $el.tooltip('dispose');
    }
    $el.tooltip({ container: 'body', boundary: 'viewport' });
  });
};
